import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function WhenStep(props) {
  const { currentStep } = useContext(ConfiguratorContext)

  if (String(currentStep) !== String(props.step)) return null

  return <>{props.children}</>
}
